import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

/** /voices — index of all 100 Voice Logs (V-001..V-100).
 *  Audio is never streamed on the list — see routes_voicelogs.list_voice_logs. */
export default function VoiceLogs() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/voice-logs")
      .then((r) => setItems(r.data))
      .catch(() => setItems([]));
  }, []);

  if (items === null) {
    return <div className="text-[#555] text-xs tracking-widest uppercase">::: tuning the dictaphone :::</div>;
  }

  const labelled = items.filter((v) => v.label || v.transcript_excerpt || v.has_audio).length;

  return (
    <div className="space-y-10" data-testid="voices-page">
      <header className="space-y-5 border-b border-[#333] pb-8">
        <div className="flex flex-wrap items-baseline gap-3">
          <span className="tiv-stamp">Voices</span>
          <span className="text-[0.6rem] tracking-[0.4em] uppercase text-[#A3A3A3]">
            character voice logs · oral testimony
          </span>
        </div>
        <h1 className="font-serif-display text-5xl sm:text-6xl tracking-tighter leading-none">
          One Hundred Voices
        </h1>
        <p className="text-sm text-[#A3A3A3] max-w-2xl leading-relaxed">
          A hundred recordings — voices recovered, transcribed, catalogued. Each carries its own
          subtitle log, written out for those who prefer the page to the ear. Click any number to
          listen, or to read.
        </p>
        <div className="text-[0.6rem] tracking-[0.4em] uppercase text-[#555]">
          {labelled} / {items.length} catalogued
        </div>
      </header>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 border-t border-l border-[#333]" data-testid="voices-grid">
        {items.map((v) => (
          <Link
            key={v.id}
            to={`/voices/${v.id}`}
            className={`group block border-r border-b border-[#333] p-4 hover:bg-[#0f0f0f] transition-colors cursor-pointer ${
              v.label || v.transcript_excerpt ? "" : "opacity-60 hover:opacity-100"
            }`}
            data-testid={`voice-card-${v.id}`}
          >
            <div className="flex items-baseline justify-between mb-2">
              <span className="font-mono-data text-[0.7rem] tracking-[0.25em] text-[#A3A3A3]">
                {v.id}
              </span>
              {v.has_audio && (
                <span
                  className="text-[0.55rem] tracking-[0.25em] uppercase text-[#E3E1D9]"
                  title="audio attached"
                  data-testid={`voice-audio-badge-${v.id}`}
                >
                  ◉ audio
                </span>
              )}
            </div>
            <div className="font-serif-display text-lg leading-tight mb-1.5 min-h-[1.5em]">
              {v.label || <span className="text-[#555] italic text-sm">unlabelled</span>}
            </div>
            {v.transcript_excerpt ? (
              <div className="text-[0.7rem] text-[#A3A3A3] leading-snug line-clamp-3">
                {v.transcript_excerpt}
              </div>
            ) : (
              <div className="text-[0.6rem] tracking-[0.3em] uppercase text-[#555]">
                — no transcript —
              </div>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
}
